// extracted by mini-css-extract-plugin
module.exports = {"container":"text-with-skips_container__3ek2r","border":"text-with-skips_border__1pUBQ","skip":"text-with-skips_skip__3S5zK"};